import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

import { computed } from 'vue'
import { useStore } from 'vuex'


export default /*#__PURE__*/_defineComponent({
  __name: 'KeepAliveRouterView',
  setup(__props) {

const store = useStore()
const include = computed(() => {
  return store.state.keepAliveIncludeItem
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view, null, {
    default: _withCtx(({ Component }) => [
      (_openBlock(), _createBlock(_KeepAlive, { include: _unref(include) }, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
      ], 1032, ["include"]))
    ]),
    _: 1
  }))
}
}

})